import styled from "styled-components";
import { VariableSizeList } from "react-window";

import { ISelectStyle } from "../../interfaces";

export const OptimizeMenuListStyle = styled(VariableSizeList)<ISelectStyle>`
  padding: 1px 0 0 0;
`;
